import React from "react";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

/* ===== Images ===== */
import Ares from "../../images/Ares.jpeg";
import ease from "../../images/easecruit.png";
import Bodyloop from "../../images/BODYLOOP_LABS.jpg";
import chematico from "../../images/chematico.jpeg";
import dakters from "../../images/Dakters.jpg";
import edith from "../../images/edith_health.jpeg";
import epilepto from "../../images/epilepto.png";
import evigway from "../../images/evigway.jpeg";
import fulectronix from "../../images/Fulectronics.webp";
import greeninv from "../../images/GREEN_INNOVOTECH.jpg";
import jyoma from "../../images/JYOMA_SOLUTIONS.jpg";
import logier from "../../images/logier.png";
import nanokriti from "../../images/nanokriti.png";
import neontram from "../../images/Neontram.jpg";
import renao from "../../images/renao.jpg";
import rosch from "../../images/rosch-crete.jpg";
import scratchnest from "../../images/Scratchnest.png";
import yoboshu from "../../images/yoboshu.png";
import vanix from "../../images/vanix.png";
import kalpakaar from "../../images/kalpakaar.png";
import touche from "../../images/touch.png";
import speedybyte from "../../images/speedbyte1.png";
import citpeels from "../../images/Citpeels.png";
import texoedge from "../../images/Texoedge.jpg";
import yInstrument from "../../images/Y Instrumentation.png";
import Fulectronics from "../../images/Fulectronics.webp";
import Huskage from "../../images/Huskage.png";
import MedXbid from "../../images/MedXbid.png";
import SVIG from "../../images/SVIG.webp";
import dronetech from "../../images/dronetech.png";
import BEF from "../../images/BFP.png";
import agniverse from "../../images/agniverse.png";
import agb from "../../images/agb solution.jpeg";
import ML from "../../images/ML.png";
import DG from "../../images/DG.png";
import zenv from "../../images/zenv.png";
import Samarthya from "../../images/Samarthya.png";
import climmatech from "../../images/climmatech.png";
import zmr from "../../images/zmr.png";
import gudlyf from "../../images/Gudlyf.png";
import Thoughtrons from "../../images/Thoughtrons1.png";
import Evizen from "../../images/Evizen.png";
import BOQO from "../../images/BOQO.png";
import crevings from "../../images/crevings.png";
import Assurity from "../../images/Assurity.png";
import Lino from "../../images/Lino.png";
import Jiyaxo from "../../images/Jiyaxo.png";
import VMS from "../../images/VMS.png";
import Unknown from "../../images/Unknown.png";
import Labrys from "../../images/Labrys.png";
import EVAYU from "../../images/Evayu.png";
import GreedyGame from "../../images/Greedy.png";
import Sookshm from "../../images/Sookshm.png";
import Mtecton from "../../images/M-Tecton.png";
import Smartrashi from "../../images/SmartRashi.png";
import ROBOZENLABS from "../../images/ROBOZENLABS.png";
import dia from "../../images/Diabuddy.png";
import alma from "../../images/Alma.png";
import lit from "../../images/LIT.png";
import GreenFinch from "../../images/Greenfinch.png";
import Farata from "../../images/Farata.png";
import GeoCore from "../../images/GeoCore.png";
import Arrivobus from "../../images/ArrivoBus.png";
import heroBackground from "../../images/innovators image.avif";
import vidyarthi from "../../images/Vidyathi_logo.jpeg";
import ironfist from "../../images/Ironfist arms private limited.png"
import Dochome from "../../images/Dochome Pvt Ltd.png"
import optimized from "../../images/Optimized Electrotech.png"
import Spingmag from "../../images/Spinmag Technologies.png"
import Believeas from "../../images/Believeas Agriculture Pvt Ltd.png"
import Pathscan from "../../images/Pathscan Technologies Pvt Ltd.png"
import Ekk from "../../images/Ekk Marketplace Technlogies Pvt Ltd.png"
import Skyyd  from "../../images/Skyyd Innovtions Pvt Ltd.png"
import Climacrest from "../../images/Climacrest Technologies Pvt Ltd.png"
import Justifying from "../../images/Justifying IT Pvt Ltd.png"
import Kadaikodi from "../../images/Kadaikodi Tech Pvt Ltd.png"
import Grid from "../../images/Grid Care pvt Ltd.png"
import Leafturn from "../../images/Leafturn wellness foods Pvt Ltd.png"
import Local from "../../images/Local lens digital Pvt Ltd.png"
import Ecozameen from "../../images/Ecozameen Pvt Ltd.png"
import urbangroomy from "../../images/urbangroomy Lifestyle Pvt Ltd.png"
import Dozer from "../../images/Dozer house.png"
import Edzero from "../../images/Edzero Pvt LTD.png"
import Pamin from "../../images/Pamin Cooltech Pvt. Ltd.png"
import Atlas  from "../../images/Atlas water Solution Pvt Ltd.png"
import Evinid  from "../../images/Evinid health pvt ltd.png"
import Zemyst from "../../images/Zemyst venture pvt ltd.png"
import OKDRIVER from "../../images/OKDRIVER SMART DASHCAMS PVT. LTD.png"
import SourcingXPress from "../../images/Get SourcingXPress Private Limited.png"
import Azentrix from "../../images/Azentrix tech Pvt Ltd.png"
import Dronosaur from "../../images/Dronosaur Private Limited.png"
import PragyanikAI from "../../images/PragyanikAI  Pvt Ltd.png"
import Aerial from "../../images/Aerial borne Pvt Ltd.png"
import OCELOR from "../../images/OCELOR TECHNOLOGIES PRIVATE LIMITED.png"
import Nesthome from "../../images/Nesthome Pvt Ltd.png"
import Nuture from "../../images/Nuture Aerospace Pvt ltd.png"
import NEXTORBIT from "../../images/NEXTORBIT SPACE PRIVATE LIMITED.png"
import Spatial from "../../images/Spatial Knott PVT LTD.png"
import CareEase from "../../images/CareEase Homecare Services Pvt. Ltd.png"
import KashWork from "../../images/KashWork Ecommerce Pvt Ltd.png"
import Astra  from "../../images/Astra Drones and Robotics Solutions Pvt Ltd.png"
import arclabs  from "../../images/Arclabs Pvt Ltd.png"
import Nineteen_ventures  from "../../images/Nineteen Ventures and Technology Pvt Ltd.png"

/* ===== Data ===== */
const incubatees = [
  { img: Arrivobus,   name: "ARRIVOBus Tech.",      link: "",                                   category: "Mobility" },
  { img: GeoCore,     name: "GEOCORE Tech.",         link: "",                                   category: "GeoTech" },
  { img: Farata,      name: "Farata Tech.",          link: "",                                   category: "AgriTech" },
  { img: GreenFinch,  name: "GreenFinch",            link: "",                                   category: "CleanTech" },
  { img: lit,         name: "L.I.T. Labs",            link: "",                                   category: "DeepTech" },
  { img: alma,        name: "Alma Threads",          link: "",                                   category: "Fashion" },
  { img: dia,         name: "Diabuddy",              link: "",                                   category: "HealthTech" },
  { img: ROBOZENLABS, name: "ROBOZENLABS",           link: "",                                   category: "Robotics" },
  { img: Smartrashi,  name: "SmartRashi",            link: "",                                   category: "FinTech" },
  { img: Mtecton,     name: "M-Tecton",              link: "",                                   category: "Construction" },
  { img: Sookshm,     name: "SOOKSHM Instruments",  link: "",                                   category: "Instrumentation" },
  { img: GreedyGame,  name: "GREEDY GAME",           link: "",                                   category: "Gaming" },
  { img: EVAYU,       name: "EVAYU",                 link: "",                                   category: "CleanTech" },
  { img: Labrys,      name: "LABRYS",                link: "",                                   category: "DeepTech" },
  // { img: Unknown,     name: "Stealth Mode",          link: "",                                   category: "Stealth" },
  { img: Jiyaxo,      name: "JIYAXO TECHNO",         link: "",                                   category: "Electronics" },
  { img: Lino,        name: "Lino",                  link: "",                                   category: "Healthcare" },
  {img: Believeas,   name: "Believeas",       link: "",                                   category: "CleanTech" },
  { img: Assurity,    name: "ASSURITY",              link: "",                                   category: "Insurance" },
  { img: crevings,    name: "CREVINGS",              link: "",                                   category: "FoodTech" },
  // { img: BOQO,     name: "BOQO",                  link: "",                                   category: "Commerce" },
  { img: Evizen,      name: "Evizen AI",             link: "",                                   category: "AI/ML" },
  { img: Thoughtrons, name: "Thoughtrons",           link: "",                                   category: "AI/ML" },
  {img: Pathscan,   name: "Pathscan Technologies",       link: "",                                   category: "CleanTech" },
  { img: gudlyf,      name: "Gudlyf",                link: "",                                   category: "HealthTech" },
 {img: Ekk,   name: "Ekk Marketplace Technlogies",       link: "",                                   category: "CleanTech" },
 {img: Skyyd,   name: "Skyyd Innovtions",       link: "",                                   category: "CleanTech" },
  { img: zmr,         name: "ZMR Mobility",          link: "",                                   category: "Mobility" },
  { img: climmatech,  name: "ClimaTech",             link: "",                                   category: "CleanTech" },
  { img: Samarthya,   name: "Samarthya Defence",     link: "",                                   category: "Defence" },
  { img: zenv,        name: "Zenv Quantum",          link: "",                                   category: "EdTech" },
 {img: Climacrest,   name: "Climacrest Technologies",       link: "",                                   category: "CleanTech" },
   {img: Justifying,   name: "Justifying ITs",       link: "",                                   category: "CleanTech" },
  {img: Kadaikodi,   name: "Kadaikodi Tech",       link: "",                                   category: "CleanTech" },
  {img: Grid,   name: "Grid Care",       link: "",                                   category: "CleanTech" },
 {img: Leafturn,   name: "Leafturn wellness foods",       link: "",                                   category: "CleanTech" },
 {img: Local,   name: "Local lens digital",       link: "",                                   category: "CleanTech" },
  { img: ease,        name: "Easecruit",             link: "http://www.easecruit.com",           category: "HR Tech" },
  { img: Ares,        name: "Ares Systems",          link: "http://www.aressystems.io/",         category: "Defence" },
  { img: speedybyte,  name: "Speedybyte",            link: "http://speedybyte.co.in/",           category: "Software" },
  { img: Bodyloop,    name: "Bodyloop Labs",         link: "",                                  category: "HealthTech" },
  { img: edith,       name: "Edith Healthcare",      link: "",                                  category: "HealthTech" },
  { img: scratchnest, name: "ScratchNest",           link: "https://scratchnest.com/",           category: "EdTech" },
  { img: vanix,       name: "Vanix Technologies",    link: "https://vanixtechnologies.com/",     category: "Electronics" },
  { img: yoboshu,     name: "Yoboshu",               link: "",                                  category: "AgriTech" },
  { img: logier,      name: "Logier Technologies",   link: "",                                  category: "Logistics" },
  { img: jyoma,       name: "Jyoma Solutions",       link: "https://jyomasolutions.com/",        category: "Defence" },
  { img: greeninv,    name: "Green Innovotech",      link: "http://www.greeninnovotech.com/",    category: "CleanTech" },
  { img: neontram,    name: "Neontram",              link: "http://www.neontram.com/",           category: "Marketing" },
  { img: nanokriti,   name: "Nanokriti",             link: "https://www.nanokriti.com/",         category: "Nanotechnology" },
  { img: rosch,       name: "Roschcrete",            link: "http://roschcrete.com/",             category: "Construction" },
  { img: renao,       name: "Renao Robotics",        link: "/",                                   category: "Robotics" },
  { img: fulectronix, name: "Fulectronix",           link: "http://www.fulectronix.in/",         category: "Robotics" },
  { img: evigway,     name: "Evigway Technologies",  link: "http://www.evigway.com/",            category: "Mobility" },
  { img: epilepto,    name: "Epilepto Systems",      link: "www.Epilepto.com",                   category: "HealthTech" },
  { img: chematico,   name: "Chematico Technologies",link: "http://www.chematico.com/",          category: "Materials" },
  { img: dakters,     name: "Dakters",               link: "",                                   category: "HealthTech" },
  { img: VMS,         name: "VMS Healthcare",             link: "https://medvolant.in/myorders", category: "HealthTech" },
  { img: kalpakaar,   name: "Kalpkaar Aesthetics",   link: "",                                   category: "Beauty" },
  { img: touche,      name: "Touch Computing",       link: "http://touchtechnologies.in/",       category: "Software" },
  { img: citpeels,    name: "CitPeels",              link: "",                                   category: "FoodTech" },
  {img: ironfist,   name: "Ironfist Arms",          link: "",                                   category: "CleanTech" },
  { img: texoedge,    name: "Texoedge",              link: "",                                   category: "Technical Textiles" },
    {img: Dochome,   name: "Dochome",                 link: "",                                   category: "CleanTech" },
      {img: optimized,   name: "Optimized Electrotech",  link: "",                                   category: "CleanTech" },
  {img: Ecozameen,   name: "Ecozameeen",       link: "",                                   category: "CleanTech" }, 
    {img: urbangroomy,   name: "Urbangroomy Lifestyle",       link: "",                                   category: "CleanTech" },
 {img: Dozer,   name: "Dozer House",       link: "",                                   category: "CleanTech" },
 {img: Edzero,   name: "Edzero",       link: "",                                   category: "CleanTech" },
  { img: yInstrument, name: "Y Instrumentation",     link: "",                                   category: "Instrumentation" },
  { img: Huskage,     name: "Huskage",               link: "",                                   category: "AgriTech" },
  // { img: MedXbid,     name: "MedXbid",               link: "",                                   category: "HealthTech" },
  { img: SVIG,        name: "SVIG",                  link: "",                                   category: "DeepTech" },
  { img: dronetech,   name: "DroneTech",             link: "",                                   category: "Drones" },
  { img: BEF,         name: "Biofield Power",                   link: "",                                   category: "Finance" },
  { img: agniverse,   name: "Agniverse",             link: "",                                   category: "Gaming" },
  { img: agb,         name: "AGB Solutions",         link: "",                                   category: "AgriTech" },
  { img: ML,          name: "ML WorkX",              link: "",                                   category: "AI/ML" },
{img: Spingmag,   name: "Spinmag Technologies",       link: "",                                   category: "CleanTech" },
  { img: DG,          name: "IDG10 Solutions",                    link: "",                      category: "Energy" },
   {img: vidyarthi,   name: "Vidyarthi Motors",          link: "",                                   category: "CleanTech" },
 {img: Pamin,   name: "Pamin Cooltech",       link: "",                                   category: "CleanTech" },
 {img: Atlas,   name: "Atlas water Solutions",       link: "",                                   category: "CleanTech" },
 {img: Evinid,   name: "Evinid health",       link: "",                                   category: "CleanTech" },
 {img: Zemyst,   name: "Zemyst venture",       link: "",                                   category: "CleanTech" },
 {img: OKDRIVER,   name: "OKDRIVER SMART DASHCAMSs",       link: "",                                   category: "CleanTech" },
 {img: SourcingXPress,   name: "Get SourcingXPress",       link: "",                                   category: "CleanTech" },
 {img: Azentrix,   name: "Azentrix tech",       link: "",                                   category: "CleanTech" },
 {img: Dronosaur,   name: "Dronosaur",       link: "",                                   category: "CleanTech" },
 {img: PragyanikAI ,   name: "PragyanikAI",       link: "",                                   category: "CleanTech" },
 {img: Aerial,   name: "Aerial borne",       link: "",                                   category: "CleanTech" },
 {img: OCELOR,   name: "OCELOR TECHNOLOGIES",       link: "",                                   category: "CleanTech" },
 {img: Nesthome,   name: "Nesthome",       link: "",                                   category: "CleanTech" },
 {img: Nuture,   name: "Nurture Aerospace",       link: "",                                   category: "CleanTech" },
 {img: NEXTORBIT,   name: "NEXTORBIT SPACE",       link: "",                                   category: "CleanTech" },
 {img: Spatial,   name: "Spatial Knott",       link: "",                                   category: "CleanTech" },
 {img: CareEase,   name: "CareEase Homecare Services",       link: "",                                   category: "CleanTech" },
 {img: arclabs,   name: "Arclabs",       link: "",                                   category: "CleanTech" },
 {img: KashWork,   name: "KashWork Ecommerce",       link: "",                                   category: "CleanTech" },
 {img: Astra,   name: "Astra Drones and Robotics Solutions",       link: "",                                   category: "CleanTech" },
 {img: Nineteen_ventures,   name: "Nineteen Ventures and Technology",       link: "",                                   category: "CleanTech" },


];

/* Network node positions for SVG background */
const networkNodes = [
  { x: 8, y: 15 }, { x: 22, y: 8 }, { x: 38, y: 20 }, { x: 55, y: 10 },
  { x: 70, y: 22 }, { x: 85, y: 12 }, { x: 92, y: 35 }, { x: 78, y: 48 },
  { x: 62, y: 38 }, { x: 45, y: 42 }, { x: 30, y: 55 }, { x: 15, y: 45 },
  { x: 5,  y: 60 }, { x: 18, y: 72 }, { x: 35, y: 68 }, { x: 52, y: 75 },
  { x: 68, y: 65 }, { x: 82, y: 78 }, { x: 95, y: 58 }, { x: 75, y: 88 },
  { x: 48, y: 88 }, { x: 25, y: 85 }, { x: 10, y: 82 },
];

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.03 } }
};

const cardVariant = {
  hidden:  { opacity: 0, y: 24, scale: 0.95 },
  visible: { opacity: 1, y: 0,  scale: 1,   transition: { duration: 0.4, ease: "easeOut" } }
};

export default function Portfolio() {
  return (
    <div className="min-h-screen font-sans text-slate-900 bg-white selection:bg-blue-100">

      {/* ===== HERO ===== */}
      <div className="relative h-[75vh] min-h-[600px] flex items-center justify-center overflow-hidden">

        {/* Background */}
        <div className="absolute inset-0 z-0">
          <motion.div
            initial={{ scale: 1.1 }}
            animate={{ scale: 1 }}
            transition={{ duration: 10, ease: "linear" }}
            className="w-full h-full"
          >
            <img src={heroBackground} alt="Portfolio Background" className="w-full h-full object-cover" />
          </motion.div>
          {/* Same exact overlay stack as About.jsx */}
          <div className="absolute inset-0 bg-slate-900/50" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent" />
        </div>

        {/* Centered content — mirrors About.jsx layout exactly */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative z-10 text-center px-4 max-w-5xl mx-auto -mt-16"
        >
          {/* Live badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-8 shadow-lg cursor-default">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500" />
            </span>
            <span className="text-blue-50 text-xs font-bold tracking-widest uppercase">
              IIT Ropar-TBIF • 250+ Startups
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6 tracking-tight drop-shadow-2xl">
            Startups Shaping{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              Tomorrow
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-slate-200 text-lg md:text-xl max-w-3xl mx-auto font-light leading-relaxed drop-shadow-md">
            A curated portfolio of deep-tech ventures born at IIT Ropar — each solving real problems, each building a self-reliant India.
          </p>
        </motion.div>
      </div>

      {/* ===== PORTFOLIO GRID ===== */}
      <section className="relative py-24 px-6 overflow-hidden">

        {/* White base */}
        <div className="absolute inset-0 bg-white" />

        {/* Fine dot grid */}
        <div className="absolute inset-0 opacity-[0.35]" style={{
          backgroundImage: 'radial-gradient(#93c5fd 1px, transparent 1px)',
          backgroundSize: '28px 28px'
        }} />

        {/* Soft ambient glows */}
        <div className="absolute top-[-10%] left-[-5%] w-[500px] h-[500px] rounded-full bg-blue-100 opacity-60 blur-3xl pointer-events-none" />
        <div className="absolute top-[30%] right-[-8%] w-[420px] h-[420px] rounded-full bg-cyan-100 opacity-50 blur-3xl pointer-events-none" />
        <div className="absolute bottom-[-5%] left-[20%] w-[380px] h-[380px] rounded-full bg-blue-50 opacity-70 blur-3xl pointer-events-none" />

        {/* SVG network graph — symbolises startup connectivity */}
        <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{ opacity: 0.12 }}>
          <line x1="8%"  y1="15%" x2="22%" y2="8%"  stroke="#3b82f6" strokeWidth="1" />
          <line x1="22%" y1="8%"  x2="38%" y2="20%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="38%" y1="20%" x2="55%" y2="10%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="55%" y1="10%" x2="70%" y2="22%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="70%" y1="22%" x2="85%" y2="12%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="85%" y1="12%" x2="92%" y2="35%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="92%" y1="35%" x2="78%" y2="48%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="78%" y1="48%" x2="62%" y2="38%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="62%" y1="38%" x2="45%" y2="42%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="45%" y1="42%" x2="30%" y2="55%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="30%" y1="55%" x2="15%" y2="45%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="15%" y1="45%" x2="5%"  y2="60%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="5%"  y1="60%" x2="18%" y2="72%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="18%" y1="72%" x2="35%" y2="68%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="35%" y1="68%" x2="52%" y2="75%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="52%" y1="75%" x2="68%" y2="65%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="68%" y1="65%" x2="82%" y2="78%" stroke="#3b82f6" strokeWidth="1" />
          <line x1="82%" y1="78%" x2="95%" y2="58%" stroke="#3b82f6" strokeWidth="1" />
          {/* Dashed cross-links */}
          <line x1="22%" y1="8%"  x2="62%" y2="38%" stroke="#0ea5e9" strokeWidth="0.8" strokeDasharray="4 6" />
          <line x1="55%" y1="10%" x2="30%" y2="55%" stroke="#0ea5e9" strokeWidth="0.8" strokeDasharray="4 6" />
          <line x1="85%" y1="12%" x2="45%" y2="42%" stroke="#0ea5e9" strokeWidth="0.8" strokeDasharray="4 6" />
          <line x1="5%"  y1="60%" x2="52%" y2="75%" stroke="#0ea5e9" strokeWidth="0.8" strokeDasharray="4 6" />
          <line x1="92%" y1="35%" x2="68%" y2="65%" stroke="#0ea5e9" strokeWidth="0.8" strokeDasharray="4 6" />
          {/* Nodes */}
          {networkNodes.map((n, i) => (
            <circle key={i} cx={`${n.x}%`} cy={`${n.y}%`} r="3.5" fill="#3b82f6" />
          ))}
        </svg>

        {/* Section heading */}
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-center mb-16"
          >
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="h-1 w-10 bg-blue-600 rounded-full" />
              <span className="text-blue-600 font-bold uppercase text-xs tracking-widest bg-white border border-blue-100 px-4 py-2 rounded-full shadow-sm">
                Portfolio Companies
              </span>
              <div className="h-1 w-10 bg-blue-600 rounded-full" />
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 leading-tight">
              Our <span className="text-blue-600">Startup Ecosystem</span>
            </h2>
            <p className="mt-4 text-slate-500 text-lg max-w-2xl mx-auto leading-relaxed">
              A growing network of deep-tech companies solving real-world challenges across every sector.
            </p>
          </motion.div>

          {/* Cards */}
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-5"
          >
            {incubatees.map((startup) => (
              <motion.div
                key={startup.name}
                variants={cardVariant}
                whileHover={{ y: -6, borderColor: '#3b82f6' }}
                className="group bg-white rounded-2xl border-2 border-slate-200 shadow-sm hover:shadow-xl hover:shadow-blue-900/10 transition-all duration-300 flex flex-col items-center p-5 overflow-hidden relative"
                onClick={() => startup.link && startup.link !== "" && startup.link !== "/" && window.open(startup.link, '_blank')}
                style={{ cursor: startup.link && startup.link !== "" && startup.link !== "/" ? 'pointer' : 'default' }}
              >
                {/* Top accent bar */}
                <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-blue-600 to-cyan-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left rounded-t-2xl" />

                {/* Logo */}
                <div className="w-full h-20 flex items-center justify-center mb-3">
                  <img
                    src={startup.img}
                    alt={startup.name}
                    title={startup.name}
                    className="max-h-full max-w-full object-contain transition-transform duration-300 group-hover:scale-110"
                  />
                </div>

                {/* Name */}
                <h3 className="font-bold text-slate-700 text-center text-xs line-clamp-2 mb-1 group-hover:text-blue-700 transition-colors leading-tight">
                  {startup.name}
                </h3>

                {/* Visit link */}
                {startup.link && startup.link !== "" && startup.link !== "/" && (
                  <div className="mt-2 opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center gap-1 text-[10px] font-semibold text-blue-600">
                    Visit <ExternalLink size={10} />
                  </div>
                )}

                {/* Glow overlay */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-400/0 to-cyan-400/0 group-hover:from-blue-400/5 group-hover:to-cyan-400/5 transition-all duration-300 pointer-events-none" />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <div className="py-24 bg-white text-center px-6 relative overflow-hidden border-t border-slate-100">

        {/* Subtle dot pattern background */}
        <div className="absolute inset-0 opacity-[0.35]" style={{
          backgroundImage: 'radial-gradient(#bfdbfe 1px, transparent 1px)',
          backgroundSize: '28px 28px'
        }} />

        {/* Soft ambient glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] rounded-full bg-blue-100/60 blur-3xl pointer-events-none" />

        <div className="max-w-4xl mx-auto relative z-10">
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {/* Eyebrow */}
            <div className="flex items-center justify-center gap-2 mb-6">
              <div className="h-px w-12 bg-blue-300" />
              <span className="text-blue-600 font-bold uppercase text-xs tracking-widest bg-white border border-blue-100 px-4 py-2 rounded-full shadow-sm">
                Scale Your Idea
              </span>
              <div className="h-px w-12 bg-blue-300" />
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight">
              Ready to Build the{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-500">
                Next Big Thing?
              </span>
            </h2>

            <p className="text-slate-500 mb-10 max-w-xl mx-auto text-lg font-light leading-relaxed">
              Join the cohort of 250+ startups transforming the world from IIT Ropar — with mentorship, funding, and infrastructure built for deep-tech.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <motion.div whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}>
                <Link
                  to="https://forms.gle/Fz2pn47EqTscZK4T8"
                  className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-full font-bold text-base shadow-xl shadow-blue-600/25 transition-all duration-300"
                >
                  Apply for Incubation
                  <ExternalLink size={16} />
                </Link>
              </motion.div>

              <motion.div whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 text-slate-600 hover:text-blue-600 font-semibold text-base px-6 py-4 rounded-full border border-slate-200 hover:border-blue-300 bg-white transition-all duration-300"
                >
                  Learn About TBIF
                </Link>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>

    </div>
  );
}